import type { AvailabilityColorType } from './colors';

export const AIR_GROUND_COLOR: AvailabilityColorType[] = [
  { main: '#62666C', secondary: '#0E5795', minPercents: 0 },
];
export const AVAILABILITY_COLOR: AvailabilityColorType[] = [
  { main: '#006A17', secondary: '#00E7331A', minPercents: 70 },
  { main: '#8B5C00', secondary: '#FFAF3833', minPercents: 50 },
  { main: '#851D24', secondary: '#FF384433', minPercents: 0 },
];
export const AVIA_SHARE_COLOR: AvailabilityColorType[] = [
  { main: '#006A17', secondary: '#00E7331A', minPercents: 70 },
  { main: '#8B5C00', secondary: '#FFAF3833', minPercents: 50 },
  { main: '#851D24', secondary: '#FF384433', minPercents: 0 },
];
export const ON_CASE_COLOR: AvailabilityColorType[] = [
  { main: '#006A17', secondary: '#00E7331A', minPercents: 70 },
  { main: '#8B5C00', secondary: '#FFAF3833', minPercents: 50 },
  { main: '#851D24', secondary: '#FF384433', minPercents: 0 },
];
export const WAITING_FOR_CASE_COLOR: AvailabilityColorType[] = [
  { main: '#851D24', secondary: '#FF384433', minPercents: 51 },
  { main: '#8B5C00', secondary: '#FFAF3833', minPercents: 31 },
  { main: '#006A17', secondary: '#00E7331A', minPercents: 0 },
];
export const NON_CASE_COLOR: AvailabilityColorType[] = [
  { main: '#851D24', secondary: '#FF384433', minPercents: 51 },
  { main: '#8B5C00', secondary: '#FFAF3833', minPercents: 31 },
  { main: '#006A17', secondary: '#00E7331A', minPercents: 0 },
];
export const NO_CREW_COLOR: AvailabilityColorType[] = [
  { main: '#0E5795', secondary: '#62666C', minPercents: 0 },
];
export const MAINTENANCE_COLOR: AvailabilityColorType[] = [
  { main: '#851D24', secondary: '#FF384433', minPercents: 21 },
  { main: '#8B5C00', secondary: '#FFAF3833', minPercents: 11 },
  { main: '#006A17', secondary: '#00E7331A', minPercents: 0 },
];
